import { Route } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import AdminDashboard from "../pages/admin/AdminDashboard";
import LeadResponse from "../pages/admin/LeadResponse";
import MarketInsightsDetails from "../pages/admin/market-insights/detail-pages/MarketInsightsDetails";
import MarketInsights from "../pages/admin/MarketInsights";
import MyProperties from "../pages/admin/MyProperties";
import ProfileAndSubscription from "../pages/admin/ProfileAndSubscription";
import AddCommercialPropertyPage from "../pages/admin/properties/add-properties/AddCommercialPropertyPage";
import AddLandPropertyPage from "../pages/admin/properties/add-properties/AddLandPropertyPage";
import AddProjectPropertyPage from "../pages/admin/properties/add-properties/AddProjectPropertyPage";
import AddResidentialPropertyPage from "../pages/admin/properties/add-properties/AddResidentialPropertyPage";
import AdminPropertyDetailsPage from "../pages/admin/properties/detail-pages/AdminPropertyDetailsPage";
import NotFoundPage from "../pages/common/NotFoundPage";

const AdminRoutes = [
  <Route key="admin" path="/admin" element={<AdminLayout />}>
    <Route index element={<AdminDashboard />} />
    <Route path="leads" element={<LeadResponse />} />
    <Route path="market-insights" element={<MarketInsights />} />
    <Route path="properties">
      <Route index element={<MyProperties />} />
      <Route path="details/:id" element={<AdminPropertyDetailsPage />} />
      <Route path="add">
        <Route path="residential" element={<AddResidentialPropertyPage />} />
        <Route path="commercial" element={<AddCommercialPropertyPage />} />
        <Route path="land" element={<AddLandPropertyPage />} />
        <Route path="project" element={<AddProjectPropertyPage />} />
      </Route>
      <Route path="edit">
        <Route
          path="residential/:id"
          element={<AddResidentialPropertyPage />}
        />
        <Route path="project/:id" element={<AddProjectPropertyPage />} />
        <Route path="commercial/:id" element={<AddCommercialPropertyPage />} />
        <Route path="land/:id" element={<AddLandPropertyPage />} />
      </Route>
    </Route>
    <Route path="market-insights">
      <Route index element={<MarketInsights />} />
      <Route path=":id" element={<MarketInsightsDetails />} />
    </Route>
    <Route path="profile-subscription" element={<ProfileAndSubscription />} />

    {/* 404 catch-all */}
    <Route path="*" element={<NotFoundPage />} />
  </Route>,
];
export default AdminRoutes;
